var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('span',{staticClass:"status-label",style:(_vm.style)},[_vm._v(_vm._s(_vm.params.value.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }